import { useRouteMatch } from 'react-router-dom';

import { ProductStatus, ProductUserStatus } from '@newModels';
import { productDetails } from '@legacyUrls';
import { useCreateProductDialog } from '@hook/useCreateProductDialog';
import { ProductDetailsStickyBar, FormData } from '@components/ProductDetailsStickyBar';
import { notifyError } from '@utils/notifications';

import { useProductDetailsStickyMobileBarQuery } from './gql/graphql.v4.generated';
import { useProductDetailsStickyBarV5Query } from './gql/graphql.v5.generated';

interface Props {
  threadUrl?: string,
}

export const ProductDetailsStickyBarContainer: React.FC<Props> = ({
  threadUrl,
}) => {
  const match = useRouteMatch<{ productId: string }>(productDetails);

  const { data, loading } = useProductDetailsStickyMobileBarQuery({
    context: {
      v4: true,
      batch: true,
      ignoreAuthError: true,
    },
    variables: {
      productId: Number(match?.params.productId),
    },
    skip: !match?.params.productId,
  });

  useProductDetailsStickyBarV5Query({
    context: {
      v5: true,
    },
    variables: {
      productId: Number(match?.params.productId),
    },
    skip: !match?.params.productId,
  });

  const handleCreateDialog = useCreateProductDialog();

  const handleSubmit = async (formData: FormData) => {
    if (!formData.body) {
      return null;
    }

    if (match?.params.productId) {
      const errors = await handleCreateDialog({
        productId: Number(match.params.productId),
        body: formData.body,
      });

      // @ts-ignore
      notifyError(errors?.body || errors?.__all__);
    }

    return null;
  };

  const product = data?.product;

  const canStartDialog = (
    data?.product?.userStatusTitle !== ProductUserStatus.Hidden
    && data?.product?.statusTitle === ProductStatus.Available
    && !data.product.seller?.isUserRestrictedByBankId
  );

  return (
    <ProductDetailsStickyBar
      isAuth={!!data?.viewer}
      isLoading={loading}
      product={product ? {
        id: product.id,
        name: product.name,
        price: product.price || 0,
        catalog: product.catalog,
        brand: product.brand,
        likes: product.likes || 0,
        isLiked: !!product.isLiked,
      } : null}
      canStartDialog={canStartDialog}
      isOwnerIsRestrictedByBankId={!!data?.product?.seller?.isUserRestrictedByBankId}
      threadUrl={threadUrl}
      onSendMessage={handleSubmit}
    />
  );
};
